import { render, staticRenderFns } from "./ParametrosCadastros.vue?vue&type=template&id=46b9752c&scoped=true&"
import script from "./ParametrosCadastros.vue?vue&type=script&lang=js&"
export * from "./ParametrosCadastros.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosCadastros.vue?vue&type=style&index=0&id=46b9752c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9752c",
  null
  
)

export default component.exports